import { render, staticRenderFns } from "./DashboardFiltersView.vue?vue&type=template&id=76ca0ea2&"
import script from "./DashboardFiltersView.vue?vue&type=script&lang=js&"
export * from "./DashboardFiltersView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFiltersView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ca0ea2')) {
      api.createRecord('76ca0ea2', component.options)
    } else {
      api.reload('76ca0ea2', component.options)
    }
    module.hot.accept("./DashboardFiltersView.vue?vue&type=template&id=76ca0ea2&", function () {
      api.rerender('76ca0ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/dashboard/filters/DashboardFiltersView.vue"
export default component.exports